import React from "react";
import PropTypes from "prop-types";

export default function ModalComponent(props) {
  return (
    <div className={`c-modal ${props.status ? "is-active" : ""} `}>
      <div
        className="c-modal__overlay"
        onClick={props.onClose ? props.onClose : () => {}}
      ></div>

      <div
        className={`c-modal__box c-form__body ${props.large ? "c-modal__box--large" : ""}`}
      >
        <div className="c-form">
          <div className="c-form__header c-modal__header">
            {props.title ? (
              <div className="c-input__title">{props.title}</div>
            ) : (
              <div />
            )}

            {props.onClose && (
              <ul className="c-form__header-actions">
                <li className="c-form__header-action">
                  <a
                    className="c-form__close"
                    onClick={props.onClose}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            )}
          </div>
          <div className="c-modal__scroll">{props.children}</div>
        </div>
      </div>
    </div>
  );
}

ModalComponent.propTypes = {
  status: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onClose: PropTypes.func,
  large: PropTypes.bool,
};

ModalComponent.defaultProps = {};